module.exports = __webpack_public_path__ + "media/images/flags/hr-2f8262cc7d07bd4ae72c616e32615304.svg";